export enum PickleballGameType {
    STANDARD = "STANDARD",
    RALLY = "RALLY",
    MLP = "MLP"
}
  
